import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom'; 

import { Sidebar, Header } from '.';
import { getUser } from '../api';
import { CenteredContent, MainContent } from '../styles';

const Layout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [userRole, setUserRole] = useState('user');
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const getUserData = async () => {
      const response = await getUser();

      const data = await response.json();

      setUserName(data.fullName);
      setUserRole(data.userRole);
    };

    getUserData();
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <div>
      <Header toggleSidebar={toggleSidebar} userRole={userRole} userName={userName} />
      <Sidebar className={isSidebarOpen ? 'open' : ''} userRole={userRole} />
      <MainContent style={{ marginLeft: isSidebarOpen ? '250px' : '0' }}>
        <CenteredContent>
          <Outlet />
        </CenteredContent>
      </MainContent>
    </div>
  );
};

export default Layout;
